<template>
  <div>
    <trac-loading v-if="logoutLoadingIndicator" />
    <trac-modal
      @close="showGettingStarted = false"
      v-if="showGettingStarted"
      size="max-w-2xl"
      class=""
    >
      <div class="">
        <h1 class="text-center text-primaryBlue pt-10 text-lg">
          Getting Started
        </h1>
        <p class="text-center text-xs md:px-24 mt-3 text-primaryGray">
          Hi <span class="text-accentDark font-medium">{{ user.name }}</span
          >, welcome to Traction, here are a few important to do before you get
          started.
        </p>
        <div class="mt-10 grid grid-cols-3 col-gap-5 row-gap-12 px-4 pb-10">
          <div
            @click="$router.push({ name: 'Kyc' })"
            :class="{ highlighted: gettingStartedChecks.kyc.status }"
            class="py-6 rounded-md cursor-pointer relative px-5 flex justify-center flex-col bg-accentLight"
          >
            <div
              v-if="gettingStartedChecks.kyc.status"
              class="absolute right-0 top-0 -mr-2 -mt-2"
            >
              <svg
                class="w-6 h-6"
                viewBox="0 0 43 43"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="21.9873"
                  cy="21.0371"
                  r="20.0681"
                  fill="#48E16A"
                  stroke="white"
                  stroke-width="1.86382"
                />
                <path
                  d="M18.2105 25.5617L13.6859 21.0371L12.1777 22.5453L18.2105 28.578L31.1378 15.6508L29.6296 14.1426L18.2105 25.5617Z"
                  fill="white"
                />
              </svg>
            </div>
            <svg
              width="31"
              height="26"
              viewBox="0 0 31 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.20117 4.85891V8.96268H30.118V4.85891L27.4351 4.1792L1.52445 4.39412L1.20117 4.85891Z"
                fill="#B2E7FF"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.3471 3.50999H27.9519C29.462 3.50999 30.6486 4.69655 30.6486 6.20671V22.387C30.6486 23.8972 29.462 25.0838 27.9519 25.0838H3.14203C1.63187 25.0838 0.445312 23.8972 0.445312 22.387V6.20671C0.445312 4.69655 1.63187 3.50999 3.14203 3.50999H10.7468C11.0165 1.67622 12.5806 0.273926 14.4683 0.273926H16.6256C18.5133 0.273926 20.0774 1.67622 20.3471 3.50999ZM16.6257 1.35261H14.4683C13.1739 1.35261 12.0952 2.2695 11.8255 3.50999H19.2684C18.9988 2.2695 17.9201 1.35261 16.6257 1.35261ZM3.1418 4.58868H27.9516C28.8685 4.58868 29.5697 5.28982 29.5697 6.20671V8.36408H1.52377V6.20671C1.52377 5.28982 2.22491 4.58868 3.1418 4.58868ZM3.1418 24.0051H27.9516C28.8685 24.0051 29.5697 23.3039 29.5697 22.387V9.44277H1.52377V22.387C1.52377 23.3039 2.22491 24.0051 3.1418 24.0051Z"
                fill="#253B95"
              />
            </svg>
            <p class="text-xs leading-5 text-primaryBlue mt-5">
              Complete Your Kyc
            </p>
          </div>

          <div
            @click="$router.push({ name: 'TerminalRequest' })"
            :class="{
              'border border-green-400':
                gettingStartedChecks.requestedTerminal.status,
            }"
            class="py-6 rounded-md cursor-pointer relative px-5 flex justify-center flex-col bg-accentLight"
          >
            <div
              v-if="gettingStartedChecks.requestedTerminal.status"
              class="absolute right-0 top-0 -mr-2 -mt-2"
            >
              <svg
                class="w-6 h-6"
                viewBox="0 0 43 43"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="21.9873"
                  cy="21.0371"
                  r="20.0681"
                  fill="#48E16A"
                  stroke="white"
                  stroke-width="1.86382"
                />
                <path
                  d="M18.2105 25.5617L13.6859 21.0371L12.1777 22.5453L18.2105 28.578L31.1378 15.6508L29.6296 14.1426L18.2105 25.5617Z"
                  fill="white"
                />
              </svg>
            </div>
            <svg
              width="28"
              height="30"
              viewBox="0 0 28 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.07 1.75884C21.07 1.94252 21.07 2.1262 21.07 2.30988C21.07 2.81733 21.07 3.32478 21.07 3.83223C21.07 4.59186 21.07 5.35148 21.07 6.1111C21.07 7.06063 21.07 8.01327 21.07 8.9628C21.07 10.0275 21.07 11.0922 21.07 12.157C21.07 13.2715 21.07 14.386 21.07 15.5037C21.07 16.6057 21.07 17.7109 21.07 18.813C21.07 19.8279 21.07 20.8397 21.07 21.8546C21.07 22.7201 21.07 23.5824 21.07 24.4479C21.07 25.0892 21.07 25.7274 21.07 26.3687C21.07 26.7205 21.07 27.0723 21.07 27.4272C21.07 27.4739 21.07 27.5206 21.07 27.5704C21.07 27.5922 21.0576 27.7603 21.0669 27.6576C21.0763 27.5611 21.0545 27.6919 21.0483 27.7168C21.042 27.7417 21.0296 27.7697 21.0233 27.7946C21.0078 27.8631 21.0389 27.7354 21.0483 27.7386C21.0514 27.7417 20.9735 27.8693 20.9673 27.8787C20.9113 27.972 21.0451 27.8039 20.9673 27.8787C20.9393 27.9067 20.9113 27.9347 20.8833 27.9627C20.7992 28.0468 20.9113 27.9316 20.9144 27.9409C20.9144 27.9409 20.8677 27.972 20.8646 27.9752C20.8459 27.9845 20.8303 27.997 20.8117 28.0063C20.7992 28.0125 20.7867 28.0187 20.7774 28.025C20.7276 28.0468 20.7307 28.0499 20.7774 28.0281C20.7774 28.0125 20.8459 28.0063 20.7774 28.0281C20.7587 28.0343 20.74 28.0405 20.7183 28.0468C20.6996 28.053 20.6778 28.0561 20.6591 28.0623C20.6093 28.0779 20.575 28.0499 20.7027 28.0623C20.6622 28.0592 20.6155 28.0686 20.5751 28.0686C20.5688 28.0686 20.5626 28.0686 20.5564 28.0686C20.2326 28.0717 19.9119 28.0686 19.5882 28.0686C18.8784 28.0686 18.1654 28.0686 17.4556 28.0686C16.4812 28.0686 15.5067 28.0686 14.5323 28.0686C13.4334 28.0686 12.3344 28.0686 11.2354 28.0686C10.1365 28.0686 9.04061 28.0686 7.94165 28.0686C6.97033 28.0686 5.99901 28.0686 5.02769 28.0686C4.3241 28.0686 3.61741 28.0686 2.91382 28.0686C2.59939 28.0686 2.28495 28.0717 1.97052 28.0686C1.96429 28.0686 1.96118 28.0686 1.95495 28.0686C1.93316 28.0686 1.91137 28.0686 1.88958 28.0654C1.74637 28.0561 1.97363 28.0966 1.86778 28.0623C1.83042 28.0499 1.78995 28.0405 1.74948 28.0281C1.68099 28.0094 1.74948 28.0156 1.74948 28.0281C1.79929 28.0499 1.79929 28.0499 1.74948 28.025C1.73703 28.0187 1.72458 28.0125 1.71524 28.0063C1.7059 28.0001 1.6125 27.944 1.6125 27.9409C1.61873 27.9316 1.72769 28.0468 1.64363 27.9627C1.63118 27.9471 1.61561 27.9347 1.60005 27.9222C1.58448 27.9067 1.57203 27.8942 1.55958 27.8787C1.5191 27.8413 1.52844 27.8693 1.55646 27.8787C1.59382 27.8911 1.58448 27.9253 1.55646 27.8787C1.5409 27.8506 1.52222 27.8195 1.50354 27.7915C1.50042 27.7884 1.47552 27.7386 1.47552 27.7386C1.48175 27.7354 1.51599 27.86 1.50042 27.7946C1.48797 27.751 1.47241 27.7012 1.45995 27.6576C1.42571 27.5518 1.45995 27.7728 1.45684 27.6576C1.45684 27.6296 1.45373 27.6016 1.45373 27.5704C1.45373 27.5206 1.45373 27.4677 1.45373 27.4179C1.45373 27.0599 1.45373 26.7019 1.45373 26.3438C1.45373 25.6963 1.45373 25.0456 1.45373 24.3981C1.45373 23.5326 1.45373 22.6703 1.45373 21.8048C1.45373 20.7836 1.45373 19.7625 1.45373 18.7445C1.45373 17.6455 1.45373 16.5466 1.45373 15.4476C1.45373 14.3331 1.45373 13.2186 1.45373 12.104C1.45373 11.0362 1.45373 9.96837 1.45373 8.90054C1.45373 7.95723 1.45373 7.01393 1.45373 6.07063C1.45373 5.31101 1.45373 4.5545 1.45373 3.79488C1.45373 3.29676 1.45373 2.79554 1.45373 2.29742C1.45373 2.09195 1.4475 1.88648 1.45684 1.68101C1.45995 1.58139 1.46618 1.72459 1.45061 1.72148C1.45061 1.72148 1.46307 1.66544 1.46307 1.66233C1.47552 1.62497 1.49108 1.5845 1.50042 1.54403C1.51599 1.47554 1.48486 1.60318 1.47552 1.60006C1.47552 1.60006 1.50665 1.5378 1.51288 1.52846C1.52222 1.50978 1.53467 1.49422 1.54401 1.47554C1.55024 1.46308 1.55958 1.45374 1.5658 1.44129C1.58448 1.41327 1.58137 1.4195 1.55335 1.45686C1.52222 1.4662 1.51599 1.49733 1.55646 1.45686C1.57514 1.43818 1.59382 1.41638 1.6125 1.40082C1.62495 1.38837 1.64363 1.37591 1.65608 1.36035C1.69967 1.30742 1.6125 1.40393 1.60939 1.39459C1.60627 1.38837 1.71524 1.32922 1.72769 1.31988C1.7308 1.31676 1.78061 1.29186 1.78061 1.29186C1.78373 1.29808 1.64675 1.33544 1.74325 1.30742C1.78684 1.29497 1.83976 1.28874 1.88335 1.27006C1.93939 1.24516 1.83354 1.27629 1.82108 1.27629C1.83976 1.2794 1.86467 1.27318 1.88335 1.27006C1.90514 1.27006 1.92693 1.26695 1.94873 1.26695C1.95495 1.26695 1.96429 1.26695 1.97052 1.26695C2.07948 1.26695 2.19156 1.26695 2.30052 1.26695C2.84222 1.26695 3.3808 1.26695 3.9225 1.26695C4.78486 1.26695 5.6441 1.26695 6.50646 1.26695C7.56495 1.26695 8.62344 1.26695 9.67882 1.26695C10.7934 1.26695 11.9079 1.26695 13.0224 1.26695C14.0684 1.26695 15.1145 1.26695 16.1605 1.26695C17.0104 1.26695 17.8634 1.26695 18.7134 1.26695C19.2333 1.26695 19.75 1.26695 20.27 1.26695C20.3634 1.26695 20.4599 1.26695 20.5533 1.26695C20.5595 1.26695 20.5626 1.26695 20.5688 1.26695C20.5844 1.26695 20.5813 1.26695 20.6124 1.26695C20.6342 1.26695 20.656 1.27006 20.6747 1.27006C20.7463 1.27318 20.6124 1.26695 20.6124 1.26384C20.6124 1.26072 20.7494 1.29808 20.7525 1.3012C20.7556 1.3012 20.8117 1.31988 20.8117 1.32299C20.8085 1.33544 20.6996 1.26072 20.7556 1.3012C20.793 1.3261 20.8397 1.34789 20.877 1.3728C20.9704 1.42884 20.8023 1.29497 20.877 1.3728C20.9082 1.40393 20.9424 1.4444 20.9735 1.47242C21.0265 1.51601 20.93 1.42884 20.9393 1.42572C20.9393 1.42572 20.9704 1.47242 20.9735 1.47554C20.9798 1.48799 21.0451 1.59695 21.042 1.59695C21.0358 1.60006 21.0016 1.47554 21.0171 1.54091C21.0234 1.55959 21.0296 1.57827 21.0358 1.60006C21.0389 1.6094 21.0669 1.72148 21.0669 1.72148C21.0483 1.72459 21.0607 1.58139 21.0607 1.68101C21.0669 1.7028 21.07 1.73082 21.07 1.75884C21.0763 2.08572 21.3534 2.39705 21.6927 2.38148C22.0258 2.36591 22.3216 2.10752 22.3153 1.75884C22.2967 0.79997 21.5308 0.0310075 20.5719 0.0185547C20.491 0.0185547 20.4132 0.0185547 20.3322 0.0185547C19.831 0.0185547 19.3267 0.0185547 18.8254 0.0185547C17.9817 0.0185547 17.1412 0.0185547 16.2975 0.0185547C15.2421 0.0185547 14.1867 0.0185547 13.1314 0.0185547C12.0013 0.0185547 10.8712 0.0185547 9.74109 0.0185547C8.67637 0.0185547 7.61165 0.0185547 6.54693 0.0185547C5.67212 0.0185547 4.79731 0.0185547 3.9225 0.0185547C3.37769 0.0185547 2.83288 0.0185547 2.28807 0.0185547C2.18222 0.0185547 2.07637 0.0185547 1.97052 0.0185547C1.22335 0.0247811 0.582028 0.473083 0.314292 1.16733C0.186651 1.50044 0.208443 1.85846 0.208443 2.21025C0.208443 2.69591 0.208443 3.18157 0.208443 3.66412C0.208443 4.4144 0.208443 5.1678 0.208443 5.91808C0.208443 6.86761 0.208443 7.81403 0.208443 8.76356C0.208443 9.83139 0.208443 10.9023 0.208443 11.9702C0.208443 13.1003 0.208443 14.2303 0.208443 15.3604C0.208443 16.475 0.208443 17.5895 0.208443 18.7071C0.208443 19.7345 0.208443 20.7587 0.208443 21.7861C0.208443 22.6609 0.208443 23.5388 0.208443 24.4137C0.208443 25.0643 0.208443 25.715 0.208443 26.3656C0.208443 26.7205 0.208443 27.0754 0.208443 27.4303C0.208443 27.502 0.20533 27.5767 0.211556 27.6483C0.280047 28.5729 1.01788 29.292 1.95495 29.3045C2.24137 29.3076 2.5309 29.3045 2.81731 29.3045C3.51467 29.3045 4.21203 29.3045 4.90939 29.3045C5.87448 29.3045 6.84269 29.3045 7.80778 29.3045C8.9192 29.3045 10.0275 29.3045 11.1389 29.3045C12.2534 29.3045 13.3711 29.3045 14.4856 29.3045C15.4725 29.3045 16.4563 29.3045 17.4432 29.3045C18.1623 29.3045 18.8783 29.3045 19.5975 29.3045C19.9182 29.3045 20.2419 29.3076 20.5626 29.3045C21.3316 29.2952 21.9853 28.8188 22.2375 28.0966C22.3091 27.8942 22.3216 27.6763 22.3216 27.4615C22.3216 27.1315 22.3216 26.8015 22.3216 26.4715C22.3216 25.8395 22.3216 25.2075 22.3216 24.5755C22.3216 23.7132 22.3216 22.8508 22.3216 21.9885C22.3216 20.9673 22.3216 19.9431 22.3216 18.922C22.3216 17.8168 22.3216 16.7085 22.3216 15.6033C22.3216 14.4732 22.3216 13.34 22.3216 12.2099C22.3216 11.1296 22.3216 10.0493 22.3216 8.96903C22.3216 8.01016 22.3216 7.05129 22.3216 6.09242C22.3216 5.32657 22.3216 4.56384 22.3216 3.79799C22.3216 3.29054 22.3216 2.78308 22.3216 2.27874C22.3216 2.1044 22.3216 1.93006 22.3216 1.75261C22.3216 1.42572 22.0351 1.1144 21.6989 1.12997C21.3565 1.15176 21.07 1.41016 21.07 1.75884Z"
                fill="#253B95"
              />
              <rect
                x="21.4453"
                y="3.75"
                width="6.25"
                height="18.75"
                fill="#B2E7FF"
              />
              <path
                d="M26.4615 6.05514C26.4615 6.93618 26.4615 7.81722 26.4615 8.69826C26.4615 10.6004 26.4615 12.5026 26.4615 14.4048C26.4615 16.2509 26.4615 18.0939 26.4615 19.9401C26.4615 20.5035 26.4615 21.067 26.4615 21.6305C26.4615 21.7644 26.4615 21.8983 26.4615 22.0321C26.4615 22.0539 26.4615 22.0757 26.4615 22.0975C26.4615 22.1255 26.4584 22.1567 26.4584 22.1847C26.4553 22.3248 26.4989 22.0508 26.4553 22.1847C26.4428 22.222 26.4335 22.2625 26.421 22.303C26.3837 22.4337 26.4926 22.1878 26.4179 22.303C26.3961 22.3372 26.3774 22.3715 26.3556 22.4057C26.2934 22.5147 26.4304 22.3466 26.3681 22.3901C26.3339 22.4151 26.2996 22.4586 26.2716 22.4898C26.1782 22.5863 26.3868 22.4244 26.2716 22.4898C26.2373 22.5084 26.2 22.5302 26.1689 22.552C26.0537 22.6236 26.2996 22.5178 26.1689 22.5551C26.1284 22.5676 26.0879 22.5769 26.0506 22.5894C25.9167 22.633 26.1906 22.5894 26.0506 22.5925C26.0163 22.5925 25.9976 22.5956 25.9634 22.5956C25.9572 22.5956 25.9509 22.5956 25.9447 22.5956C25.8544 22.5956 25.761 22.5956 25.6707 22.5956C25.2629 22.5956 24.852 22.5956 24.4441 22.5956C23.5818 22.5956 22.7194 22.5956 21.8539 22.5956C21.801 22.5956 21.7481 22.5956 21.6921 22.5956C21.9006 22.8042 22.1061 23.0097 22.3147 23.2183C22.3147 22.6112 22.3147 22.0072 22.3147 21.4001C22.3147 19.9432 22.3147 18.4893 22.3147 17.0323C22.3147 15.2702 22.3147 13.5113 22.3147 11.7492C22.3147 10.2268 22.3147 8.70448 22.3147 7.18212C22.3147 6.44429 22.3427 5.70335 22.3147 4.96552C22.3147 4.95618 22.3147 4.94373 22.3147 4.93439C22.1061 5.14297 21.9006 5.34845 21.6921 5.55703C23.0899 5.55703 24.4908 5.55703 25.8887 5.55703C25.9136 5.55703 25.9354 5.55703 25.9603 5.55703C26.0007 5.55703 26.0506 5.56637 26.091 5.56326C25.9416 5.5726 26.0288 5.55703 26.0879 5.5726C26.1128 5.57882 26.1408 5.58816 26.1657 5.5975C26.228 5.62241 26.2156 5.61618 26.1284 5.58194C26.1284 5.57882 26.228 5.63486 26.2342 5.64109C26.256 5.65665 26.2778 5.66911 26.2996 5.68467C26.228 5.62863 26.2156 5.61929 26.2685 5.66288C26.2903 5.68778 26.3152 5.70958 26.3401 5.73448C26.449 5.83722 26.2965 5.65043 26.3556 5.75005C26.3743 5.78429 26.3961 5.82165 26.4179 5.85278C26.4459 5.91194 26.4428 5.89948 26.4055 5.81543C26.4148 5.84033 26.4241 5.86524 26.4335 5.89326C26.4366 5.9026 26.4646 6.01467 26.4646 6.01467C26.4553 5.91816 26.4522 5.90571 26.4584 5.9742C26.4584 5.99911 26.4615 6.02712 26.4615 6.05514C26.4677 6.38203 26.7448 6.69335 27.0841 6.67778C27.4172 6.66222 27.713 6.40382 27.7068 6.05514C27.6881 5.09628 26.9254 4.33043 25.9634 4.31486C25.7455 4.31175 25.5275 4.31486 25.3065 4.31486C24.3601 4.31486 23.4137 4.31486 22.4672 4.31486C22.2089 4.31486 21.9505 4.31486 21.6921 4.31486C21.3558 4.31486 21.0694 4.60128 21.0694 4.9375C21.0694 5.54458 21.0694 6.14854 21.0694 6.75561C21.0694 8.2126 21.0694 9.66646 21.0694 11.1234C21.0694 12.8855 21.0694 14.6445 21.0694 16.4066C21.0694 17.9289 21.0694 19.4513 21.0694 20.9736C21.0694 21.7115 21.0539 22.4524 21.0694 23.1902C21.0694 23.1996 21.0694 23.212 21.0694 23.2214C21.0694 23.5576 21.3558 23.844 21.6921 23.844C22.377 23.844 23.065 23.844 23.7499 23.844C24.4846 23.844 25.2193 23.8534 25.954 23.844C26.8631 23.8316 27.5791 23.1622 27.6912 22.2718C27.7037 22.1598 27.7037 22.0508 27.7037 21.9387C27.7037 21.4904 27.7037 21.0421 27.7037 20.5907C27.7037 19.8093 27.7037 19.0279 27.7037 18.2465C27.7037 17.2658 27.7037 16.2851 27.7037 15.3045C27.7037 14.2678 27.7037 13.2311 27.7037 12.1975C27.7037 11.2511 27.7037 10.3047 27.7037 9.35826C27.7037 8.63288 27.7037 7.9075 27.7037 7.18212C27.7037 6.82411 27.7099 6.46609 27.7037 6.10807C27.7037 6.0925 27.7037 6.07694 27.7037 6.06137C27.7037 5.73448 27.4172 5.42316 27.081 5.43873C26.7448 5.44807 26.4615 5.70646 26.4615 6.05514Z"
                fill="#253B95"
              />
              <path
                d="M17.5704 4.90306C17.5704 6.31334 17.5704 7.72051 17.5704 9.13079C17.5704 9.80325 17.5704 10.4788 17.5704 11.1513C17.5704 11.1948 17.5673 11.2353 17.5704 11.2789C17.5704 11.2945 17.5299 11.2602 17.5704 11.3225C17.5735 11.2945 17.5766 11.2696 17.5797 11.2415C17.5735 11.2696 17.5673 11.2945 17.558 11.3225C17.5829 11.3225 17.5891 11.1762 17.5673 11.2851C17.5611 11.2976 17.5517 11.3069 17.5455 11.3194C17.6015 11.2478 17.6078 11.2353 17.5642 11.2851C17.586 11.2696 17.6078 11.254 17.6264 11.2384C17.6046 11.254 17.5797 11.2696 17.558 11.282C17.5829 11.2727 17.6078 11.2633 17.6327 11.254C17.6078 11.2633 17.5797 11.2727 17.5517 11.2758C17.5424 11.2509 17.7167 11.2727 17.5891 11.2665C17.5081 11.2633 17.4241 11.2665 17.3431 11.2665C16.0076 11.2665 14.6689 11.2665 13.3333 11.2665C11.453 11.2665 9.57257 11.2665 7.6922 11.2665C6.99484 11.2665 6.29748 11.2665 5.60012 11.2665C5.30437 11.2665 5.0055 11.254 4.70974 11.2665H4.70663C4.56031 11.2727 4.84361 11.2976 4.70352 11.2665C4.56342 11.2353 4.82804 11.3256 4.70352 11.2633C4.58521 11.2073 4.77512 11.3287 4.71908 11.2727C4.66304 11.2166 4.78446 11.4065 4.72842 11.2882C4.66616 11.1606 4.75644 11.4252 4.72531 11.2882C4.69418 11.1482 4.71908 11.4315 4.72531 11.2851C4.72531 11.2478 4.72531 11.2104 4.72531 11.1762C4.72531 10.9271 4.72531 10.6749 4.72531 10.4259C4.72531 9.53551 4.72531 8.64513 4.72531 7.75787C4.72531 6.95155 4.72531 6.14834 4.72531 5.34202C4.72531 5.19881 4.73153 5.05249 4.72531 4.90928C4.72531 4.89372 4.76267 4.92174 4.72531 4.8657C4.7222 4.89372 4.71908 4.91862 4.71597 4.94664C4.7222 4.91862 4.72842 4.89372 4.73776 4.8657C4.72842 4.8906 4.71908 4.91551 4.70974 4.94042C4.7222 4.91551 4.73776 4.89372 4.75333 4.87192C4.73776 4.89372 4.7222 4.91551 4.70663 4.93419C4.75644 4.88749 4.74399 4.89372 4.67238 4.95287C4.68484 4.94664 4.69418 4.9373 4.70663 4.93108C4.75333 4.90617 4.75333 4.90306 4.70663 4.92485C4.69418 4.93108 4.68172 4.93419 4.66927 4.94042C4.69418 4.93108 4.7222 4.92174 4.75021 4.91862C4.75644 4.94042 4.58833 4.92174 4.71597 4.92796C4.74087 4.92796 4.76578 4.92796 4.79069 4.92796C5.96125 4.92796 7.13493 4.92796 8.3055 4.92796C10.1952 4.92796 12.088 4.92796 13.9778 4.92796C15.1577 4.92796 16.3376 4.92796 17.5175 4.92796C17.5424 4.92796 17.5704 4.92796 17.5953 4.92796H17.5984C17.7012 4.92485 17.5548 4.94042 17.5611 4.91862C17.5735 4.92174 17.5891 4.92485 17.6015 4.92796C17.6669 4.94976 17.6545 4.94353 17.5673 4.9124C17.5797 4.91862 17.5922 4.92485 17.6015 4.93419C17.6576 4.97155 17.6482 4.96532 17.5735 4.90928C17.6731 4.99023 17.5237 4.79409 17.5797 4.90928C17.6264 5.02759 17.5362 4.76296 17.5704 4.90306C17.5673 4.75362 17.6015 5.04315 17.5704 4.90306C17.5829 5.22683 17.8475 5.54126 18.193 5.5257C18.5199 5.51013 18.8281 5.25174 18.8157 4.90306C18.7908 4.19947 18.246 3.67645 17.5455 3.67334C17.4147 3.67334 17.284 3.67334 17.1563 3.67334C16.5586 3.67334 15.9609 3.67334 15.3663 3.67334C13.4796 3.67334 11.5962 3.67334 9.70955 3.67334C8.19965 3.67334 6.68663 3.67334 5.17672 3.67334C5.03663 3.67334 4.89653 3.67334 4.75644 3.67334C4.1805 3.67645 3.64814 4.03136 3.51116 4.61042C3.46135 4.819 3.47691 5.04315 3.47691 5.25796C3.47691 5.5973 3.47691 5.93353 3.47691 6.27287C3.47691 7.91042 3.47691 9.54485 3.47691 11.1824C3.47691 11.2291 3.47691 11.2789 3.47691 11.3287C3.50493 11.8704 3.87852 12.353 4.41399 12.4806C4.57587 12.518 4.73153 12.5148 4.89342 12.5148C5.39465 12.5148 5.89899 12.5148 6.40021 12.5148C8.21833 12.5148 10.0333 12.5148 11.8514 12.5148C13.4952 12.5148 15.139 12.5148 16.7828 12.5148C17.0661 12.5148 17.3556 12.5273 17.6389 12.5148C18.3487 12.4775 18.825 11.8984 18.825 11.2073C18.825 10.9614 18.825 10.7154 18.825 10.4664C18.825 8.74476 18.825 7.02626 18.825 5.30466C18.825 5.17079 18.825 5.03692 18.825 4.90306C18.825 4.57617 18.5386 4.26485 18.2024 4.28042C17.8568 4.29598 17.5704 4.55438 17.5704 4.90306Z"
                fill="#253B95"
              />
              <path
                d="M6.60868 15.2888C5.98293 15.2888 5.36028 15.2888 4.73453 15.2888C4.40764 15.2888 4.09632 15.5752 4.11189 15.9115C4.12745 16.2477 4.38585 16.5341 4.73453 16.5341C5.36028 16.5341 5.98293 16.5341 6.60868 16.5341C6.93557 16.5341 7.24689 16.2477 7.23132 15.9115C7.21576 15.5752 6.95736 15.2888 6.60868 15.2888Z"
                fill="#253B95"
              />
              <path
                d="M17.1634 15.2888C16.5376 15.2888 15.915 15.2888 15.2892 15.2888C14.9623 15.2888 14.651 15.5752 14.6666 15.9115C14.6821 16.2477 14.9405 16.5341 15.2892 16.5341C15.915 16.5341 16.5376 16.5341 17.1634 16.5341C17.4903 16.5341 17.8016 16.2477 17.786 15.9115C17.7704 15.5752 17.512 15.2888 17.1634 15.2888Z"
                fill="#253B95"
              />
              <path
                d="M6.64579 24.009C6.02004 24.009 5.39739 24.009 4.77164 24.009C4.44475 24.009 4.13343 24.2954 4.149 24.6317C4.16456 24.9679 4.42296 25.2543 4.77164 25.2543C5.39739 25.2543 6.02004 25.2543 6.64579 25.2543C6.97268 25.2543 7.284 24.9679 7.26843 24.6317C7.25287 24.2923 6.99447 24.009 6.64579 24.009Z"
                fill="#253B95"
              />
              <path
                d="M17.2005 24.009C16.5747 24.009 15.9521 24.009 15.3263 24.009C14.9994 24.009 14.6881 24.2954 14.7037 24.6317C14.7193 24.9679 14.9776 25.2543 15.3263 25.2543C15.9521 25.2543 16.5747 25.2543 17.2005 25.2543C17.5274 25.2543 17.8387 24.9679 17.8231 24.6317C17.8107 24.2923 17.5523 24.009 17.2005 24.009Z"
                fill="#253B95"
              />
            </svg>

            <p class="text-xs leading-5 text-primaryBlue mt-5">
              Request <br />
              Terminal
            </p>
          </div>
          <div
            @click="$router.push({ name: 'FixedAccount' })"
            :class="{
              highlighted: gettingStartedChecks.hasCreatedFixedAccount.status,
            }"
            class="py-6 rounded-md cursor-pointer relative px-5 flex justify-center flex-col bg-accentLight"
          >
            <div class="absolute right-0 top-0 -mr-2 -mt-2">
              <svg
                v-if="gettingStartedChecks.hasCreatedFixedAccount.status"
                class="w-6 h-6"
                viewBox="0 0 43 43"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="21.9873"
                  cy="21.0371"
                  r="20.0681"
                  fill="#48E16A"
                  stroke="white"
                  stroke-width="1.86382"
                />
                <path
                  d="M18.2105 25.5617L13.6859 21.0371L12.1777 22.5453L18.2105 28.578L31.1378 15.6508L29.6296 14.1426L18.2105 25.5617Z"
                  fill="white"
                />
              </svg>
            </div>
            <svg
              width="33"
              height="29"
              viewBox="0 0 33 29"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.5469 8.71025L26.1667 0.900085L31.0756 9.61046L17.8274 17.2593L12.5469 8.71025Z"
                fill="#B2E7FF"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M26.6028 0.152252C26.4424 0.109213 26.2643 0.127718 26.1059 0.218736L12.1818 8.25782C12.0232 8.34936 11.917 8.49527 11.8737 8.6567C11.8359 8.79773 11.8456 8.95227 11.9098 9.0944C11.9185 9.1152 11.9286 9.13568 11.9402 9.1557L17.1161 18.1207C17.2069 18.2778 17.3529 18.3833 17.515 18.4267C17.6759 18.4698 17.8546 18.451 18.012 18.3602L31.9361 10.3211C32.0948 10.2295 32.2009 10.0835 32.2441 9.92223C32.282 9.78106 32.2722 9.62625 32.2079 9.48414C32.1992 9.46346 32.1892 9.44313 32.1776 9.42324L27.0022 0.459179L27.0017 0.45824C26.9109 0.301181 26.765 0.195611 26.6028 0.152252ZM17.8281 17.2593L13.0414 8.96847L26.2896 1.31961L31.0763 9.61044L17.8281 17.2593Z"
                fill="#253B95"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.38408 19.6191H0.660626H0.135742V20.144V28.0016V28.5265H0.660626H3.38408H3.90899V28.0016V20.144V19.6191H3.38408ZM1.18544 20.669H2.85906V27.4767H1.18544V20.669Z"
                fill="#253B95"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.85938 20.9964V26.7933L2.85939 26.7933V27.2525L3.31663 27.3121C4.37524 27.45 5.38593 27.5955 6.33156 27.7316L6.33196 27.7317C9.94526 28.2518 12.5986 28.6335 15.3187 28.1717C18.0456 27.7088 20.7769 26.4066 24.5018 23.5627L24.6761 23.3248C24.8776 22.7685 24.9938 22.3628 25.0356 22.0797C25.1155 21.5378 24.9621 21.228 24.6068 21.0969C24.0256 20.8823 22.8568 21.3637 21.2706 22.0171L21.2702 22.0173L21.2695 22.0175C19.6145 22.6993 17.4998 23.5704 15.1667 24.0308C12.9453 24.4692 10.5167 24.5357 8.08845 23.7035L13.497 20.9993C14.0506 20.7225 14.0428 20.6513 13.9773 20.061L13.9737 20.0284L13.9735 20.0284C13.8999 19.3634 13.4649 18.465 11.6832 18.3516C10.2049 18.2575 7.63538 18.7302 3.18948 20.5105L2.85938 20.6427V20.9964ZM3.90913 26.3348V21.3513L3.90914 21.3513C7.98025 19.7467 10.3034 19.3137 11.6175 19.3973C12.6297 19.4618 12.8853 19.8312 12.9286 20.1147L7.44843 22.8547C7.33085 22.9023 7.22281 22.9742 7.13209 23.0668C7.04095 23.1597 6.96809 23.2716 6.9212 23.3989C6.83645 23.6289 6.86721 23.8833 6.9506 24.0884C6.9907 24.1872 7.0453 24.2802 7.10568 24.356C7.19386 24.4667 7.30513 24.5528 7.42711 24.5977C7.47425 24.6151 7.52191 24.6268 7.56991 24.6324C10.2605 25.6002 12.935 25.5403 15.3676 25.0601C17.7921 24.5816 19.966 23.6861 21.6673 22.9853L21.6679 22.9851C22.7038 22.5584 23.5332 22.2167 23.9626 22.1085C23.92 22.2905 23.8478 22.5265 23.7434 22.8235C20.2311 25.4884 17.6704 26.7097 15.1463 27.1383C12.586 27.573 10.0004 27.201 6.47938 26.6941L6.47899 26.6941L6.47778 26.6939C5.70657 26.5829 4.88889 26.4652 3.90913 26.3348Z"
                fill="#253B95"
              />
            </svg>

            <p class="text-xs leading-5 text-primaryBlue mt-5">
              Create A fixed account
            </p>
          </div>
          <div
            @click="$router.push({ name: 'Pos' })"
            :class="{
              highlighted: gettingStartedChecks.firstSale.status,
            }"
            class="py-6 rounded-md cursor-pointer relative px-5 flex justify-center flex-col bg-accentLight"
          >
            <div class="absolute right-0 top-0 -mr-2 -mt-2">
              <svg
                v-if="gettingStartedChecks.firstSale.status"
                class="w-6 h-6"
                viewBox="0 0 43 43"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="21.9873"
                  cy="21.0371"
                  r="20.0681"
                  fill="#48E16A"
                  stroke="white"
                  stroke-width="1.86382"
                />
                <path
                  d="M18.2105 25.5617L13.6859 21.0371L12.1777 22.5453L18.2105 28.578L31.1378 15.6508L29.6296 14.1426L18.2105 25.5617Z"
                  fill="white"
                />
              </svg>
            </div>
            <svg
              width="33"
              height="29"
              viewBox="0 0 33 29"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.5469 8.71025L26.1667 0.900085L31.0756 9.61046L17.8274 17.2593L12.5469 8.71025Z"
                fill="#B2E7FF"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M26.6028 0.152252C26.4424 0.109213 26.2643 0.127718 26.1059 0.218736L12.1818 8.25782C12.0232 8.34936 11.917 8.49527 11.8737 8.6567C11.8359 8.79773 11.8456 8.95227 11.9098 9.0944C11.9185 9.1152 11.9286 9.13568 11.9402 9.1557L17.1161 18.1207C17.2069 18.2778 17.3529 18.3833 17.515 18.4267C17.6759 18.4698 17.8546 18.451 18.012 18.3602L31.9361 10.3211C32.0948 10.2295 32.2009 10.0835 32.2441 9.92223C32.282 9.78106 32.2722 9.62625 32.2079 9.48414C32.1992 9.46346 32.1892 9.44313 32.1776 9.42324L27.0022 0.459179L27.0017 0.45824C26.9109 0.301181 26.765 0.195611 26.6028 0.152252ZM17.8281 17.2593L13.0414 8.96847L26.2896 1.31961L31.0763 9.61044L17.8281 17.2593Z"
                fill="#253B95"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.38408 19.6191H0.660626H0.135742V20.144V28.0016V28.5265H0.660626H3.38408H3.90899V28.0016V20.144V19.6191H3.38408ZM1.18544 20.669H2.85906V27.4767H1.18544V20.669Z"
                fill="#253B95"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.85938 20.9964V26.7933L2.85939 26.7933V27.2525L3.31663 27.3121C4.37524 27.45 5.38593 27.5955 6.33156 27.7316L6.33196 27.7317C9.94526 28.2518 12.5986 28.6335 15.3187 28.1717C18.0456 27.7088 20.7769 26.4066 24.5018 23.5627L24.6761 23.3248C24.8776 22.7685 24.9938 22.3628 25.0356 22.0797C25.1155 21.5378 24.9621 21.228 24.6068 21.0969C24.0256 20.8823 22.8568 21.3637 21.2706 22.0171L21.2702 22.0173L21.2695 22.0175C19.6145 22.6993 17.4998 23.5704 15.1667 24.0308C12.9453 24.4692 10.5167 24.5357 8.08845 23.7035L13.497 20.9993C14.0506 20.7225 14.0428 20.6513 13.9773 20.061L13.9737 20.0284L13.9735 20.0284C13.8999 19.3634 13.4649 18.465 11.6832 18.3516C10.2049 18.2575 7.63538 18.7302 3.18948 20.5105L2.85938 20.6427V20.9964ZM3.90913 26.3348V21.3513L3.90914 21.3513C7.98025 19.7467 10.3034 19.3137 11.6175 19.3973C12.6297 19.4618 12.8853 19.8312 12.9286 20.1147L7.44843 22.8547C7.33085 22.9023 7.22281 22.9742 7.13209 23.0668C7.04095 23.1597 6.96809 23.2716 6.9212 23.3989C6.83645 23.6289 6.86721 23.8833 6.9506 24.0884C6.9907 24.1872 7.0453 24.2802 7.10568 24.356C7.19386 24.4667 7.30513 24.5528 7.42711 24.5977C7.47425 24.6151 7.52191 24.6268 7.56991 24.6324C10.2605 25.6002 12.935 25.5403 15.3676 25.0601C17.7921 24.5816 19.966 23.6861 21.6673 22.9853L21.6679 22.9851C22.7038 22.5584 23.5332 22.2167 23.9626 22.1085C23.92 22.2905 23.8478 22.5265 23.7434 22.8235C20.2311 25.4884 17.6704 26.7097 15.1463 27.1383C12.586 27.573 10.0004 27.201 6.47938 26.6941L6.47899 26.6941L6.47778 26.6939C5.70657 26.5829 4.88889 26.4652 3.90913 26.3348Z"
                fill="#253B95"
              />
            </svg>

            <p class="text-xs leading-5 text-primaryBlue mt-5">
              Make First <br />
              Sale
            </p>
          </div>
          <div
            @click="$router.push({ name: 'AddProduct' })"
            :class="{
              highlighted: gettingStartedChecks.hasAddedAProduct.status,
            }"
            class="py-6 px-5 rounded-md cursor-pointer relative flex justify-center flex-col bg-accentLight"
          >
            <div
              v-if="gettingStartedChecks.hasAddedAProduct.status"
              class="absolute right-0 top-0 -mr-2 -mt-2"
            >
              <svg
                class="w-6 h-6"
                viewBox="0 0 43 43"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="21.9873"
                  cy="21.0371"
                  r="20.0681"
                  fill="#48E16A"
                  stroke="white"
                  stroke-width="1.86382"
                />
                <path
                  d="M18.2105 25.5617L13.6859 21.0371L12.1777 22.5453L18.2105 28.578L31.1378 15.6508L29.6296 14.1426L18.2105 25.5617Z"
                  fill="white"
                />
              </svg>
            </div>
            <svg
              width="32"
              height="26"
              viewBox="0 0 32 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.6726 25.2086V22.5139C22.6726 19.5373 20.0987 17.1243 16.9237 17.1243H6.86315C3.68812 17.1243 1.11426 19.5373 1.11426 22.5139V25.2086"
                stroke="#253B95"
                stroke-width="1.03646"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <circle
                cx="11.8935"
                cy="6.34515"
                r="5.38958"
                fill="#B2E7FF"
                stroke="#253B95"
                stroke-width="1.03646"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <p class="text-xs leading-5 text-primaryBlue mt-5">
              Add a new <br />
              Product
            </p>
          </div>
        </div>
      </div>
    </trac-modal>
    <!-- Username and Getting Started Mini Check UI -->
    <div class="flex mt-5 mb-8 items-center">
      <div class="flex-1">
        <h6 class="text-xs">Hello,</h6>
        <h2 class="text-lg font-semibold">{{ user.name }}</h2>
      </div>
      <div
        @click="showGettingStarted = true"
        class="hidden sm:block max-w-xs w-11/12 md:w-full cursor-pointer px-6 relative small-shadow rounded-md py-4 bg-white"
      >
        <div class="flex items-center">
          <img src="@/assets/svg/award.svg" class="w-10 ml-3 h-10" alt="" />
          <div class="tiny ml-6 pr-10">
            Complete each descriptions provided to help serve you better
          </div>
          <svg
            class="w-6 h-6 absolute top-0 right-0 -mr-2 -mt-1 inline-flex"
            viewBox="0 0 27 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="13.5"
              cy="14"
              r="13.5"
              fill="#253B95"
              fill-opacity="0.33"
            />
            <circle
              cx="13.5"
              cy="14"
              r="10.5"
              fill="#253B95"
              fill-opacity="0.72"
            />
            <circle cx="13.4546" cy="14" r="6.54541" fill="#253B95" />
          </svg>
        </div>
        <!-- <div
            :style="`width: ${progress}%`"
            class="h-1 rounded-full -mb-px absolute bottom-0 left-0 bg-blue-700"
          ></div> -->
      </div>
    </div>

    <!-- Offline Message -->
    <trac-offline></trac-offline>

    <!-- Recent Transactions and Graphs -->
    <div
      class="big-shadow bg-white gap-x-10 px-5 py-8 grid grid-cols-1 md:grid-cols-2"
    >
      <div class="col-span-1">
        <trac-home-recent-transactions
          :sales-or-transactions="salesOrTransactions"
          :showValues="showValuesForOnlyAdmin"
        />
      </div>
      <div class="col-span-1 rounded-md">
        <graph-info :showValues="showValuesForOnlyAdmin" @toggleUpdate="updateToggle" />
      </div>
    </div>
    <!-- End Recent Transactions and Graphs -->

    <!-- Wallet Balance and Grow with traction -->
    <div class="my-5 gap-x-5 py-3 grid grid-cols-1 md:grid-cols-2">
      <div class="col-span-1 big-shadow bg-white rounded-md">
        <wallet-info />
      </div>
      <div
        v-if="isAdminAccount"
        class="col-span-1 p-5 big-shadow gwt-box rounded-md"
      >
        <div class="p-4 flex flex-col gap-y-2 min-h-full text-center">
          <div class="mx-6">
            <h1 class="text-lg font-bold mt-0 mb-4">Grow With Traction</h1>
            <p class="smallest">
              Grow with Traction helps Traction SMEs have access <br />
              to more ways of growing their business.
            </p>
            <!-- <a :href="'https://grow-with-traction.netlify.app/#/?email='+emailAddress" target="_blank" class="outline-button mt-5 mb-2 smallest tracking-5 active:bg-purple focus:border-secondaryPurple border-primaryBlue border focus:text-secondaryPurple focus:outline-none"> Visit website to learn more </a> -->
            <a
              href="#"
              data-test="learn-more"
              @click="$router.push({ name: 'GWT' })"
              class="outline-button mt-5 mb-2 smallest tracking-5 active:bg-purple focus:border-secondaryPurple border-primaryBlue border focus:text-secondaryPurple focus:outline-none"
              >Visit to learn more</a
            >
          </div>
          <div class="w-full">
            <img
              src="@/assets/svg/grow-with-traction.svg"
              class="w-1/3 mx-auto"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- End Wallet Balance and Grow with traction -->

    <!-- Call to Actions (Loan and Payment Options) -->
    <div
      v-if="isAdminAccount"
      class="my-5 gap-x-5 py-3 grid grid-cols-1 md:grid-cols-2"
    >
      <!-- <div class="col-span-1 mb-6 light-pale-blue rounded">
        <div class="flex items-center px-6 min-h-full">
          <div class="flex-1 my-4 rounded">
            <h3 class="text-base font-bold">
              Access Traction loan to power your business
            </h3>
            <router-link
             data-test="apply-here"
              to="/loan"
              class="outline-button my-3 text-xs tracking-5 active:bg-purple focus:border-secondaryPurple focus:text-secondaryPurple focus:outline-none bg-white"
            >
              Apply Here</router-link
            >
          </div>
          <img class="w-32" src="@/assets/svg/homepage-get-loan.png" alt="" />
        </div>
      </div> -->
      <div class="col-span-1 mb-6 rounded light-pale-orange">
        <div class="flex items-center px-6 min-h-full">
          <div class="flex-1 my-4 rounded">
            <h3 class="text-base font-bold">
              Expand Your Payment options today. Get one of our POS Machines
            </h3>
            <router-link
              data-test="request-POS"
              to="/terminal-request"
              class="outline-button my-3 text-xs tracking-5 active:bg-purple focus:border-secondaryPurple focus:text-secondaryPurple focus:outline-none border border-primaryBlue"
            >
              Request a POS</router-link
            >
          </div>
          <img class="w-32" src="@/assets/svg/home-pos-image.png" alt="" />
        </div>
      </div>
      <div class="col-span-1 mb-6 rounded light-green">
        <div class="flex items-center px-6 min-h-full">
          <div class="flex-1 my-4 rounded">
            <h3 class="text-base font-bold">
              Do you know you can start saving from your transactions daily to
              grow your business?
            </h3>
            <router-link
              :to="{ name: 'SavingsWaitlist' }"
              class="outline-button my-3 text-xs tracking-5 active:bg-purple focus:border-secondaryPurple focus:text-secondaryPurple focus:outline-none bg-white"
            >
              Learn More</router-link
            >
          </div>
          <img class="w-32" src="@/assets/svg/piggy.svg" alt="" />
        </div>
      </div>
    </div>
    <!-- End Call to Actions (Loan and Payment Options) -->
  </div>
</template>

<script>
import {
  GET_USER_DATA,
  GET_USER_BUSINESS_DATA,
  GET_LOCAL_DB_DATA,
  SAVE_LOCAL_DB_DATA,
  GET_USER_BUSINESS_ID,
} from '../../browser-db-config/localStorage';
import moment from 'moment';
import RecentTransactions from './RecentTransactions.vue';
import WalletComponent from './Wallet.vue';
import GraphComponent from './Graph.vue';
export default {
  data() {
    return {
      salesOrTransactions: false,
      showGettingStarted: false,
      gettingStartedChecks: {
        firstSale: { status: true },
        hasAddedAProduct: { status: true },
        hasCreatedFixedAccount: { status: true },
        kyc: { status: true },
        requestedTerminal: { status: true },
      },
      user: GET_USER_DATA(),
      businessDetail: GET_USER_BUSINESS_DATA(),
      authRole: GET_USER_DATA().role ? GET_USER_DATA().role.toLowerCase() : '',
    };
  },
  components: {
    'trac-home-recent-transactions': RecentTransactions,
    'wallet-info': WalletComponent,
    'graph-info': GraphComponent,
  },
  async created() {
    const isAdmin = this.user.role.toLowerCase() === 'Admin'.toLowerCase();
    if (isAdmin) {
      if (this.hasBeenCheckedForGettingStarted()) {
        this.showGettingStarted = false;
      } else {
        await this.getChecks();
      }
    }
  },
  computed: {
    logoutLoadingIndicator() {
      return this.$store.getters.GET_LOGOUT_LOADING
    },
    showValuesForOnlyAdmin() {
      if (GET_USER_BUSINESS_ID() === '6336e4946d9b9e0003c72543') {
        return this.isAdminAccount
      } else {
        return true
      }
    },
    isAdminAccount() {
      return this.authRole === 'admin';
    },
    emailAddress() {
      return this.businessDetail.email || '';
    },
    allChecksOut() {
      const rules = Object.keys(this.gettingStartedChecks).map(
        (check) => this.gettingStartedChecks[check].status
      );
      console.log('rules for checks', rules);
      return rules.every((status) => status === true) || false;
    },
    allchartData() {
      return {
        type: 'area',
        backgroundColor: 'none',
        scaleY: {
          lineColor: 'none',
          tick: {
            visible: false,
          },
          guide: {
            visible: false,
          },
          item: {
            visible: false,
          },
        },
        scaleX: {
          label: {
            /* Add a scale title with a label object. */
            text: `Sales Margins from mondy to saturday
            `,
          },
          /* Add your scale labels with a labels array. */
          labels: ['mon', 'tue', 'wed', 'thur', 'fri', 'sat'],
        },
        series: [
          {
            values: [3, 5, 6, 8, 9, 0],
            'background-color': '#07b2c9 #234398',
            'alpha-area': 0.2,
            'line-color': '#253B95',
            marker: {
              'background-color': '#ffffff' /* hexadecimal or RGB value */,
              size: 4 /* in pixels */,
              'border-color': '#253b95' /* hexadecimal or RBG value */,
              'border-width': 2 /* in pixels */,
            },
          },
        ],
      };
    },
  },
  methods: {
    hasBeenCheckedForGettingStarted() {
      let hasBeenChecked = false;
      const now = Date.now();
      const sessionKey = `getting-started-${GET_USER_BUSINESS_ID()}`;
      const beginningOfToday =
        moment(now).startOf('day').unix().valueOf() * 1000;
      const endOfToday = moment(now).endOf('day').unix().valueOf() * 1000;
      const timeChecked = GET_LOCAL_DB_DATA(sessionKey);
      const isANumber = typeof timeChecked === 'number';
      const wasCheckedToday =
        timeChecked > beginningOfToday && timeChecked < endOfToday;
      if (isANumber && wasCheckedToday) {
        hasBeenChecked = true;
      } else {
        hasBeenChecked = false;
        SAVE_LOCAL_DB_DATA(sessionKey, now);
      }
      // debugger
      return hasBeenChecked;
    },
    updateToggle(toggle) {
      // console.log('toggled: ', toggle)
      this.salesOrTransactions = toggle;
    },
    async getChecks() {
      const checks = await this.$store
        .dispatch('GETTING_STARTED')
        .catch((err) => {
          console.error('Error Getting Checks: ', err);
        });
      console.log('gettingStarted: ', checks);
      if (checks && checks.status && checks.data) {
        this.gettingStartedChecks = checks.data;
        this.showGettingStarted = this.allChecksOut === false;
      } else {
        this.showGettingStarted = false;
      }
    },
  },
};
</script>

<style lang="postcss" scoped>
.light-pale-orange {
  background: #f7d3a04d;
}
.light-pale-blue {
  background: #b2e7ff;
}

.light-green {
  background: #b2fffa;
}
.highlighted {
  @apply border border-green-400;
}
.outline-button {
  @apply inline-block
              px-5
              font-semibold
              text-primaryBlue
              py-2
              rounded
              leading-6
              tracking-normal;
}
.gwt-box {
  background: #f6fcff;
  border: 15px solid white;
}
</style>
